'use client';

import { Children, cloneElement } from 'react';

import { useHeader } from '../context/HeaderContextProps';

import type { FC, ReactElement } from 'react';

export interface HeaderScrollerProps {
  children: ReactElement | ReactElement[];
}

export const HeaderScroller: FC<HeaderScrollerProps> = ({ children }) => {
  const { isScrolling } = useHeader();

  return (
    <>
      {Children.map(
        children,
        (child, index) => cloneElement( child, { key: index, isScrolling } )
      )}
    </>
  );
};
